import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { hasValidInput } from 'components/Model/ModelUtils';
import ModelType from 'components/Model/ModelType';
import ModelsContainer from 'components/Model/ModelsContainer';

import DataSourceProvider from './DataSourceProvider';
import DataSourceAsset from './DataSourceAsset';
import { DATA_SOURCE } from '../WizardConstants';

// TODO: Probably don't need to use ModelContainer if we only have one input
const providerModel = [
  {
    type: ModelType.RADIO_GROUP,
    label: 'Data Source',
    path: 'dataSource',
    isRequired: true,
    hasError: _.isEmpty,
    radios: [
      { id: DATA_SOURCE.provider, label: 'Provider' },
      { id: DATA_SOURCE.asset, label: 'Asset' }
    ]
  }
];

const WizardStepDataSource = ({ assetInfo, setAssetInfo, addErrorAlert, providers, isLoadingProviders, setIsValid }) => {
  const [dataSourceValid, setDataSourceValid] = useState(false);

  useEffect(() => {
    setIsValid(hasValidInput(assetInfo, providerModel) && dataSourceValid);
  }, [assetInfo, dataSourceValid, setIsValid]);

  return (
    <>
      <ModelsContainer models={providerModel} data={assetInfo} setData={setAssetInfo} />
      { (assetInfo?.dataSource === DATA_SOURCE.provider)
        && <DataSourceProvider
          assetInfo={assetInfo}
          setAssetInfo={setAssetInfo}
          providers={providers}
          isLoadingProviders={isLoadingProviders}
          addErrorAlert={addErrorAlert}
          setIsValid={setDataSourceValid}
        /> }
      { (assetInfo?.dataSource === DATA_SOURCE.asset)
        && <DataSourceAsset
          assetInfo={assetInfo}
          setAssetInfo={setAssetInfo}
          addErrorAlert={addErrorAlert}
          setIsValid={setDataSourceValid}
        /> }
    </>
  );
};

export default WizardStepDataSource;
